import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'ig-news-entry',
    templateUrl: './news-entry.component.html',
    styleUrls: ['./news-entry.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NewsEntryComponent {
  news = input<any[]>();
}
